import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	loadingSpinnerContainer: {},
});
